export default __webpack_public_path__ + "static/media/plan.34bbbc79.svg";